<template>
  <TemplatePopup
    :showMessage="saveDisabled"
    :fullScreen="fullScreen"
    :geometry="entity.geometry"
  >
    <div slot="header" class="header-container">
      <div class="header-title">
        <strong>Caixa de emendas</strong>
        <CreationDate :date="entity.created" />
      </div>
    </div>
    <div slot="body">
      <tabs>
        <tab title="Dados" :selected="true">
          <b-form-group label="Nome (TAG):">
            <b-form-input
              id="inputName"
              v-model="entity.name"
              :class="{ 'is-invalid': missingName }"
              maxlength="50"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Modelo:">
            <b-form-select
              id="modelList"
              v-model="modelId"
              :class="{ 'is-invalid': missingModel }"
              size="sm"
            >
              <b-form-select-option
                v-for="entityList in modelList"
                :value="entityList.id"
                :key="entityList.id"
              >
                {{ entityList.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Endereço:">
            <b-form-input
              id="inputAddress"
              v-model="entity.address"
              maxlength="255"
              :class="{ 'is-invalid': missingAddress }"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            label="Endereços sugeridos:"
            v-if="isNew && entity.category != 'I'"
          >
            <b-form-select id="addressList" v-model="entity.address" size="sm">
              <b-form-select-option
                v-for="(address, index) in addressList"
                :value="address.formatted_address"
                :key="index"
              >
                {{ address.formatted_address }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Cabos sangria:" v-if="cableList.length">
            <b-form-select
              id="modelBleedCable"
              v-model="entity.cable"
              :disabled="!isNew"
              size="sm"
              title="Para fazer a sangria ou quebrar um cabo selecione na lista, caso não deseje quebrar o cabo deixe o campo em vazio"
            >
              <b-form-select-option :value="null">-</b-form-select-option>
              <b-form-select-option
                v-for="(cable, index) in cableList"
                :value="cable"
                :key="index"
              >
                {{ cable.name }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>

          <b-form-group label="Pasta:">
            <b-form-select
              id="selectFolder"
              v-model="entity.folderId"
              size="sm"
            >
              <b-form-select-option
                v-for="entityList in folderList"
                :value="entityList.id"
                :key="entityList.id"
              >
                {{ entityList.name }}
              </b-form-select-option>
            </b-form-select>

          </b-form-group>
          <b-form-group label="Cor:">
            <ColorSelect v-model="entity.color" :valueDefault='color'/>
            </b-form-group>
          
          <b-form-group label="Bloco:" v-if="entity.category === 'I'">
            <b-form-input
              id="inputBlock"
              v-model="entity.block"
              maxlength="50"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Andar:" v-if="entity.category === 'I'">
            <b-form-input
              type="number"
              id="inputFloor"
              v-model="entity.floor"
              size="sm"
            ></b-form-input>
          </b-form-group>

          <div class="row mt-2" v-if="!isNew">
            <div class="col-md-6 col-sm-12 mb-1">
              <CardUsage
                id="usage"
                text="Taxa de utilização:"
                :value="entity.usage"
              />
            </div>
            <div class="col-md-6 col-sm-12 mb-1">
              <Card
                id="avaliableEquipments"
                text="Portas disponíveis:"
                :value="entity.avaliableEquipments"
              />
            </div>
          </div>
        </tab>
        <tab
          id="tabCables"
          title="Cabos"
          v-if="!isNew"
          :permission="['CAB', 'VI']"
        >
          <Cables :equipmentId="entity.id" />
        </tab>
        <tab
          id="tabSplitter"
          title="Splitter"
          v-if="!isNew"
          :permission="['SPL', 'VI']"
        >
          <Splitter
            ref="splitterTab"
            :equipmentId="entity.id"
            :updateAction="null"
            :showAttendance="false"
          />
        </tab>
        <tab
          id="ConnectedEquipment"
          title="Clientes Conectados"
          :permission="['SPL', 'VI']"
          v-if="!isNew"
        >
          <ConnectedEquipment
            :equipmentId="entity.id"
            :updateAction="getOne"
            :showAttendance="true"
            equipmentType="C"
          />
        </tab>
      </tabs>
    </div>
    <div slot="button">
      <div class="text-center">
        <b-button-group>
          <b-button
            id="btnOtdr"
            :disabled="isNew"
            @click.prevent="OTDR()"
            v-has-permission.permission="['OTR', 'VI']"
            variant="muted"
          >
            <i class="fa fa-map-marker fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">OTDR</p>
          </b-button>
          <b-button
            id="btnActing"
            :disabled="isNew"
            @click.prevent="drawnLimit()"
            v-has-permission.permission="['DRA', 'VI']"
            variant="muted"
          >
            <i class="fa fa-object-group fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Atuação</p>
          </b-button>

          <b-button
            id="btnReport"
            :disabled="isNew"
            @click.prevent="connectionReport()"
            v-has-permission.permission="['REL', 'VI']"
            variant="muted"
          >
            <i class="fa fa-bar-chart fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Relatório</p>
          </b-button>

          <b-button
            id="btnComments"
            :disabled="isNew"
            @click.prevent="comment()"
            v-has-permission.permission="['COM', 'VI']"
            variant="muted"
          >
            <i class="fa fa-comments fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Comentários</p>
          </b-button>

          <b-button
            id="btnImage"
            :disabled="isNew"
            @click.prevent="image()"
            v-has-permission.permission="['IMG', 'VI']"
            variant="muted"
          >
            <i class="fa fa-picture-o fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Imagem</p>
          </b-button>

          <b-button
            id="btnConnections"
            :disabled="isNew"
            @click.prevent="conexao()"
            v-has-permission.permission="['CON', 'VI']"
            variant="muted"
          >
            <i class="fa fa-sitemap fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Conexões</p>
          </b-button>

          <b-button
            id="btnDelete"
            :disabled="isNew"
            @click.prevent="remove()"
            v-has-permission.permission="['CAI', 'EX']"
            variant="muted"
          >
            <i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
            <p class="button-text mb-0">Excluir</p>
          </b-button>

          <b-button
            id="btnSave"
            @click.prevent="save()"
            v-has-permission.permission="['CAI', 'AL', 'CA']"
            variant="muted"
            :disabled="saveDisabled"
          >
            <i class="fa fa-floppy-o fa-lg"></i>
            <p class="button-text mb-0">Salvar</p>
          </b-button>
        </b-button-group>
      </div>
    </div>
  </TemplatePopup>
</template>

<script>
import TemplatePopup from "../../../template/TemplatePopup";
import Splitter from "./Tabs/Splitter";
import Cables from "./Tabs/Cables";
import {
  amendmentPath,
  amendmentModelSimplePath,
  folderSimplePath,
} from "../../../router/ApiPaths";
import PopupBase from "./PopupBase";
import Card from "../../../components/extra/Card";
import CardUsage from "../../../components/extra/CardUsage";
import Tabs from "./Tabs/Tabs";
import Tab from "./Tabs/Tab";
import CreationDate from "./CreationDate"
import ConnectedEquipment from "./Tabs/ConnectedEquipment.vue";
import ColorSelect from "../../map/components/ColorSelect.vue";
import { getAction } from "../../../components/MessageBus";
import { openSubPopup } from "./index";

export default {
  name: "AmendmentMap",
  extends: PopupBase,
  components: {
    TemplatePopup,
    Splitter,
    Cables,
    Card,
    CardUsage,
    Tabs,
    Tab,
    CreationDate,
    ConnectedEquipment,
    ColorSelect
  },
  data() {
    return {
      modelList: [],
      folderList: [],
      color: "yellow"
    };
  },
  beforeMount() {
    this.entity = {
      id: null,
      ceoModel: { id: null },
      cable: null,
      color: this.color,
      category: this.extra && this.extra.category ? this.extra.category : "E",
      address:
        this.extra && this.extra.address
          ? this.extra.address
          : this.entity.address,
      equipmentExternalId:
        this.extra && this.extra.equipmentExternalId
          ? this.extra.equipmentExternalId
          : undefined,
      positionDiagram:
        this.extra && this.extra.positionDiagram
          ? this.extra.positionDiagram
          : undefined,
    };
  },
  mounted() {
    let path = amendmentPath(this.folderId);

    this.getAllDirect(amendmentModelSimplePath).then((data) => {
      this.modelList = data;
    });

    this.getAllDirect(folderSimplePath).then((data) => {
      this.folderList = data;
    });

    if (this.extra && this.extra.category === "I") this.init(path);
    else this.init(path, true, this.isNew);
  },
  computed: {
    modelId: {
      get() {
        return this.entity.ceoModel ? this.entity.ceoModel.id : null;
      },
      set(value) {
        this.$set(this.entity, "ceoModel", { id: value });
      },
    },
    missingModel: function () {
      return !this.entity.ceoModel || !this.entity.ceoModel.id;
    },
    missingName: function () {
      return !this.entity.name;
    },
    missingAddress: function () {
      return !this.entity.address;
    },
    saveDisabled: function () {
      return this.missingName || this.missingModel || this.missingAddress || !this.isDirty;
    },
    bgc() {
      this.colors.hex;
      return this.colors.hex;
    }
  },
  methods: {
    updateValue(value) {
      this.colors = value;
      this.entity.color = value.hex;
    },
    conexao() {
      openSubPopup(3, null, this.id || this.entity.id, this.entity);

      getAction((result) => {
        if (result) {
          this.getOne();
          this.atualizarListaSplitters();
        }
      });
    },
    atualizarListaSplitters() {
      if (this.$refs.splitterTab && typeof this.$refs.splitterTab.atualizaDados === 'function') {
        this.$refs.splitterTab.atualizaDados();
      }
    }
  }
};
</script>
